import { jsx as m } from "react/jsx-runtime";
import g from "react";
import { useContextualStyle as u } from "../../Style/Style.js";
import { ui as d } from "../../ui.js";
import { clsx as x } from "../../../utils/clsx.js";
import '../../../assets/Box.css';const p = "_root_1e1ao_1", k = "_grow_1e1ao_7", r = {
  root: p,
  "no-overflow": "_no-overflow_1e1ao_1",
  "no-shrink": "_no-shrink_1e1ao_4",
  grow: k,
  "no-grow": "_no-grow_1e1ao_10"
};
function f(t) {
  return typeof t == "string" ? t : d.q(t);
}
const B = g.forwardRef(function(s, a) {
  const {
    noOverflow: w = !1,
    noShrink: _ = !1,
    grow: n = void 0,
    width: e,
    height: i,
    children: l,
    className: c
  } = s, h = x(r.root, c, {
    [r["no-overflow"]]: w,
    [r["no-shrink"]]: _,
    [r["no-grow"]]: n === !1,
    [r.grow]: n === !0
  }), o = {
    ...u(),
    ...s.style || {}
  };
  return (e || i) && (e && (o.width = f(e)), i && (o.height = f(i))), !o.width && n === !0 && (o.width = "1px"), /* @__PURE__ */ m("div", { ref: a, className: h, style: o, children: l });
});
export {
  B as Box
};
